import React, { Component } from "react";

import { Select } from "@rocketseat/unform";
import Placa from "../Amarelo/Placa";

export default class Verde extends Component {
  /** Parte do formulário do filtro VERDE */
  render() {
    return (
      <div>
        <div className="d-flex">
          <label className="big">Proprietário é o condutor:</label>
          <div className="filtro__input_container">
            <Select
              className="ant-input"
              name="prop_is_cond"
              options={[
                { id: 1, title: "SIM" },
                { id: 2, title: "NÃO" }
              ]}
            />
          </div>
        </div>
        <br />
        <div className="d-flex">
          <label className="big">B.O está correto?</label>
          <div className="filtro__input_container">
            <Select
              className="ant-input"
              name="bo_correto"
              options={[
                { id: 1, title: "SIM" },
                { id: 2, title: "NÃO" }
              ]}
            />
          </div>
        </div>
        <br />
        <Placa />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Filtro/components/Verde/index.js